import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

export interface MedioTransporteItem {
  id: number;
  descripcion: string;
  estado: number;
  fechaCreacion?: string;
  fechaModificacion?: string;
}

@Injectable({
  providedIn: "root",
})
export class MedioTransporteService {
  private apiUrl = `${environment.apiUrl}/api/medio_transporte`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<MedioTransporteItem[] | { mediosTransporte?: MedioTransporteItem[] }> {
    return this.http.get<MedioTransporteItem[] | { mediosTransporte?: MedioTransporteItem[] }>(this.apiUrl, {
      withCredentials: true,
    });
  }
}
